import React from "react";
import ButtonCell from "../buttons/ButtonCell";
import TextInputCell from "../gridCells/TextInputCell";
import TextCellInfo from "../gridCells/TextCellInfo";
import { examples } from "../../constants/constants";
import { ActionResult } from "../../interfaces/ActionResult";
import { AlertLevel } from "../../types/AlertTypes";

export default () => {
  const [command, setCommand] = React.useState("");
  const [result, setResult] = React.useState<ActionResult>({
    success: true,
    message: "",
    level: AlertLevel._5_VERBOSE,
  });
  const [currentExample, setCurrentExample] = React.useState(0);

  const handleCommandChange = (event: any) => {
    setCommand(event.target.value);
  };

  const showExample = () => {
    if (examples.length < 1) {
      alert("Can't show examples if there are none.");
      return;
    }
    setCommand(examples[currentExample]);
    setCurrentExample((currentExample + 1) % examples.length);
  };

  const submitCommand = () => {
    const commandToSubmit = command.trim();
    const result = window.rpgAction(commandToSubmit);
    setResult(result);
  };

  const runAllExamples = () => {
    let hasFailed: boolean = false;
    examples.forEach((example) => {
      const result: ActionResult = window.rpgAction(example);
      hasFailed = !result.success || hasFailed;
    });
    if (hasFailed) {
      setResult({
        success: false,
        message: "At least one example failed.",
        level: AlertLevel._1_ERROR,
      });
    } else {
      setResult({
        success: true,
        message: "All examples passed.",
        level: AlertLevel._4_LOG,
      });
    }
  };

  let resultMessage;
  if (result.message && result.message.trim().length > 0) {
    resultMessage = (
      <TextCellInfo
        dataTest="command-result-message"
        classes={result.success ? "" : "warning"}
        text={result.message}
      />
    );
  }
  return (
    <div className="grid-container grid-container-width">
      <TextCellInfo dataTest="command-api-title" text="Command API" />
      <TextInputCell
        key="command-input"
        dataTest="command-input"
        placeholder="Enter a Command"
        onChange={(event: any) => handleCommandChange(event)}
        value={command}
      />
      <ButtonCell
        key="send-command"
        dataTest="send-command"
        buttonText="Send"
        onClick={submitCommand}
      />
      {resultMessage}
      <ButtonCell
        buttonText="Show Example"
        dataTest="show-example"
        onClick={showExample}
      />
      <ButtonCell
        buttonText="Run All Examples"
        dataTest="run-all-examples"
        onClick={runAllExamples}
      />
    </div>
  );
};
